import BN from 'bn.js';
import { ZqField, Scalar } from '@toruslabs/ffjavascript';
import { keccak256 } from '@toruslabs/metadata-helpers';

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
const F = new ZqField(Scalar.fromString("21888242871839275222246405745257275088548364400416034343698204186575808495617"));
const SEED = "mimcsponge";
const NROUNDS = 220;
function keccak256Padded(str) {
  let finalInput = Buffer.from(str, "utf8");
  if (typeof str === "string" && str.slice(0, 2) === "0x" && str.length === 66) {
    finalInput = Buffer.from(str.slice(2), "hex");
  }
  return `0x${keccak256(finalInput).toString("hex").padStart(64, "0")}`;
}
function mimgGetIV(seed) {
  let _seed = seed;
  if (typeof _seed === "undefined") _seed = SEED;
  const c = keccak256Padded(`${_seed}_iv`);
  const cn = Scalar.fromString(new BN(c, 16).toString());
  const iv = cn.mod(F.p);
  return iv;
}
function mimcGetConstants(seed, nRounds) {
  let _nRounds = nRounds;
  if (typeof nRounds === "undefined") _nRounds = NROUNDS;
  const cts = new Array(_nRounds);
  let c = keccak256Padded(SEED);
  for (let i = 1; i < _nRounds; i += 1) {
    c = keccak256Padded(c);
    const n1 = new BN(c.slice(2), 16).mod(new BN(F.p.toString()));
    const c2 = n1.toString(16, 64);
    cts[i] = F.e(new BN(c2, 16).toString());
  }
  cts[0] = F.e(0);
  cts[cts.length - 1] = F.e(0);
  return cts;
}
const cts = mimcGetConstants(SEED, NROUNDS);
function mimcHash(_xL_in, _xR_in, _k) {
  let xL = F.e(_xL_in);
  let xR = F.e(_xR_in);
  const k = F.e(_k);
  for (let i = 0; i < NROUNDS; i += 1) {
    const c = cts[i];
    const t = i === 0 ? F.add(xL, k) : F.add(F.add(xL, k), c);
    const xR_tmp = F.e(xR);
    if (i < NROUNDS - 1) {
      xR = xL;
      xL = F.add(xR_tmp, F.pow(t, 5));
    } else {
      xR = F.add(xR_tmp, F.pow(t, 5));
    }
  }
  return {
    xL: F.normalize(xL),
    xR: F.normalize(xR)
  };
}
function mimcMultiHash(arr, key, numOutputs) {
  let _key = key;
  let _numOutputs = numOutputs;
  if (typeof _numOutputs === "undefined") {
    _numOutputs = 1;
  }
  if (typeof _key === "undefined") {
    _key = F.zero;
  }
  let R = F.zero;
  let C = F.zero;
  for (let i = 0; i < arr.length; i += 1) {
    R = F.add(R, F.e(arr[i]));
    const S = mimcHash(R, C, _key);
    R = S.xL;
    C = S.xR;
  }
  const outputs = [R];
  for (let i = 1; i < _numOutputs; i += 1) {
    const S = mimcHash(R, C, _key);
    R = S.xL;
    C = S.xR;
    outputs.push(R);
  }
  if (_numOutputs === 1) {
    return F.normalize(outputs[0]);
  }
  return outputs.map(x => F.normalize(x));
}

const SECP256K1_CURVE_N = "fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141";

// creates sub-keys via MiMC hash, output keys are not padded
function subkey(keyHex, input) {
  const privKeyBuf = new BN(keyHex, "hex").toString(10);
  // TODO: check against existing usage of mimc
  // TODO: check that MPC is possible with mimc, with tests
  const inputPath = new BN(input).umod(new BN(SECP256K1_CURVE_N, "hex")).toString(10);
  const output = mimcHash(1, privKeyBuf, inputPath);
  return output.xL.toString(16);
}

export { SECP256K1_CURVE_N, mimcGetConstants, mimcHash, mimcMultiHash, mimgGetIV, subkey };
//# sourceMappingURL=openloginSubkey.esm.js.map
